import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-04.module.css';

const tagBoxMotion = {
    hidden: { opacity: 1 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1  // 각 자식 요소 사이의 딜레이
        }
    }
};

const tagMotion = {
    hidden: { y: 50, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            mass: 1,
            stiffness: 150,
            damping: 15
        }
    }
};

const spanMotion = {
    hidden: { y: 50, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            mass: 1,
            stiffness: 80,
            damping: 15,
            delay: 0.8
        }
    }
};

export default function Main04() {
    const mobile = useMediaQuery('(max-width: 768px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const ref = useRef(null);
      
    const isInView = useInView(ref, {
        once: true,
        amount: mobile ? (mobileMedium ? 0.1 : 0.4) : 0.8,
        margin: mobileMedium ? '-20px 0px' : ' -90px 0px'
    });

    const problemMap = ['재고 관리 실패', '납품 지연', '자재 부족', '설비 고장', '품질 불량'];

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} ref={ref}>
                <motion.div 
                    className={styles.boxTag}
                    initial='hidden'
                    animate={isInView ? 'visible' : 'hidden'}
                    variants={tagBoxMotion}
                >
                    {problemMap.map((problem, index) => (
                        <motion.div
                            key={index}
                            className={styles.tag} 
                            variants={tagMotion}
                        >
                            {problem}
                        </motion.div>
                    ))}
                    {(mobile || mobileLarge) ? null : <p>문제를 겪고 있다면</p>}
                </motion.div>
                <p>
                    {(mobile || mobileLarge) ? '문제를 겪고 있다면 원인은' : '원인은'}
                    <motion.span
                        initial='hidden'
                        animate={isInView ? 'visible' : 'hidden'}
                        variants={spanMotion}
                    >
                        &nbsp;&nbsp;데이터 단절입니다.
                    </motion.span>
                </p>
            </div>
        </div>
    );
}
